<template>
  <div>
    <v-list-item dense class="py-1">
      <v-list-item-avatar size="28" class="my-0">
        <v-img :src="avatar_img" />
      </v-list-item-avatar>
      <v-list-item-content class="py-0">
        <v-list-item-title class="text-body-2">
          {{ nome[0] }}
          <span v-if="nome[1]" class="grey--text text-caption"
            >— {{ nome[1] }}</span
          >
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action class="my-0">
        <v-chip x-small outlined color="grey darken-1">{{
          gruppo.items.length
        }}</v-chip>
      </v-list-item-action>
    </v-list-item>
    <SerraColturaElement
      v-for="item in gruppo.items"
      :key="item.coltura.id"
      :coltura="item"
      style="padding-left: 40px"
      @cambia_stato="$emit('cambia_stato')"
    />
  </div>
</template>

<script>
import SerraColturaElement from "./SerraColturaElement.vue";

export default {
  name: "SerraProdottoGruppoElement",
  components: { SerraColturaElement },
  props: {
    // { id_prodotto, items: [{ coltura, lotto }] } — tutte le colture dello
    // stesso prodotto in una serra, raggruppate perché lo stesso prodotto
    // può avere più lotti/fornitori diversi posizionati insieme.
    gruppo: Object,
  },
  computed: {
    prodotto() {
      return this.$store.getters.get_prodotto_by_id(this.gruppo.id_prodotto);
    },
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.gruppo.id_prodotto
      );
    },
    nome() {
      return this.prodotto ? this.prodotto.nome.split(" in ") : ["Prodotto"];
    },
  },
};
</script>
